import React from 'react'
import personaSkeletonAvatar from "../../assets/png/profile-pics.png";

const ResultPersonasModal = ({ clickedPersona, isOpen }) => {
    if (!clickedPersona || !isOpen) return null;
    return (
        <>

            <div className="h-full py-6 px-10 rounded-xl bg-white overflow-auto">

                <div className='flex flex-col gap-4 h-full'>

                    <div className='relative flex justify-between items-center w-full'>

                        <div className='flex gap-3'>
                            <div className="w-[52px] h-[52px] flex justify-center items-center rounded-full overflow-hidden bg-[#F7F8FA] ">
                                <img
                                    src={clickedPersona?.avatar_url || personaSkeletonAvatar}
                                    alt={` persona`}
                                    className="rounded-full object-contain"
                                    height={52}
                                    width={52}
                                    loading='lazy'
                                />
                            </div>

                            <div className='flex flex-col gap-[2px]' >
                                <span className='font-semibold text-xl text-[#060606]'>{clickedPersona?.persona_name || 'Loading...'}</span>
                                <span className='font-medium teaxt-base text-[#060606]'>{clickedPersona?.consumer_segment_name || 'Loading...'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='border-[1.21px] border-[#E1E1E1] rounded-[9.67px] p-5 flex flex-col gap-2 flex-grow max-h-[calc(100%-100px)] overflow-y-auto'>
                        <span className='text-[#060606] font-semibold text-sm '>Description:</span>

                        <span className='font-normal text-sm text-[#393939] whitespace-pre-line'>{clickedPersona?.persona_description || 'Loading...'}</span>
                    </div>
                </div>

            </div>

        </>
    )
}

export default ResultPersonasModal
